import { injectable, inject } from 'inversify';
import type { IAuthRepository } from '@/domain/repositories/IAuthRepository';
import { Verify2FASetupCommand } from '@/application/commands/auth/Verify2FASetupCommand';
import { TYPES } from '@/di/tokens';

@injectable()
export class Verify2FASetupAction {
  constructor(
    @inject(TYPES.IAuthRepository) private authRepository: IAuthRepository
  ) {}

  async execute(command: Verify2FASetupCommand): Promise<void> {
    await this.authRepository.verify2FASetup(command.code, command.secret);
  }
}
